import { Pipe, PipeTransform } from "@angular/core";
import { UtilService } from "../providers/util.service";
@Pipe({ name: "sort" })
export class SortPipe implements PipeTransform {
  constructor(private util: UtilService) {}
  transform(array: any[], field: string): any[] | null {
    if (array) {
      var newArray = this.util.copyArray(array);
      newArray.sort((a: any, b: any) => {
        if (a[field] < b[field]) {
          return -1;
        } else if (a[field] > b[field]) {
          return 1;
        } else {
          return 0;
        }
      });
      return newArray;
    } else return null;
  }
}
